/**
 * 监听窗口滚动方向和高性能公共方法
 * @param {Function} callback - 滚动变化时的回调函数，接收滚动数据和方向参数
 * @param {number} threshold - 滚动判断阈值，默认为5像素，避免微小滚动误判 [6,7](@ref)
 * @returns {Function} 清理函数，用于移除事件监听
 */
export const listenScrollDirection = (callback, threshold = 5) => {
  if (typeof callback !== 'function') {
      throw new Error('Callback must be a function');
  }

  let lastScrollY = window.pageYOffset;
  let ticking = false;

  const updateScrollDir = () => {
      const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
      
      // 计算滚动距离差值
      const scrollDelta = currentScrollY - lastScrollY;
      
      // 只有当滚动距离超过阈值时才判断方向 [6,7](@ref)
      if (Math.abs(scrollDelta) < threshold) {
          ticking = false;
          return;
      }
      
      // 判断滚动方向：向下滚动时currentScrollY增大，向上滚动时减小 [1,7](@ref)
      const direction = currentScrollY > lastScrollY ? 'down' : 'up';
      
      // 回调函数返回滚动数据和方向
      callback({
          direction: direction,
          scrollY: currentScrollY,
          deltaY: scrollDelta,
          scrollDirection: direction,
          scrollDistance: currentScrollY
      });
      
      lastScrollY = currentScrollY > 0 ? currentScrollY : 0;
      ticking = false;
  };

  const onScroll = () => {
      if (!ticking) {
          // 使用requestAnimationFrame优化性能，确保在浏览器重绘前执行 [2](@ref)
          window.requestAnimationFrame(updateScrollDir);
          ticking = true;
      }
  };

  // 添加滚动事件监听，使用passive: true提升滚动性能 [5](@ref)
  window.addEventListener('scroll', onScroll, { passive: true });

  // 返回清理函数
  return () => {
      window.removeEventListener('scroll', onScroll);
  };
};

/**
* 获取当前滚动位置的辅助函数
* @returns {Object} 包含滚动位置和方向信息的对象
*/
export const getScrollPosition = () => {
  const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  return {
      scrollY: scrollY,
      scrollDistance: scrollY,
      direction: null // 实时方向需要监听器获取
  };
};